import { useState as o, useCallback as u, useEffect as s, useRef as E, useLayoutEffect as I } from "react";
import { BREAKPOINTS as p } from "./libServer.js";
import { EVENTS_HE as K, LOCALIZED_DOMAINS as N, MODULES_HE as U, addDaysToDate as Z, calculateDaysDifference as j, convertDateToISODateString as q, debounce as G, dispatchEvent as J, formatDateToLocale as Q, getHeaders as X, getReverseRanges as Y, getServerHeaders as $, isBetween as ee, isBrowser as te, isSameDay as ne, parseCookies as re } from "./libServer.js";
function O(e) {
  const [t, n] = o(!!e), r = u(() => n(!0), []), i = u(() => n(!1), []), f = u(() => n((w) => !w), []);
  return { value: t, setValue: n, setTrue: r, setFalse: i, toggle: f };
}
function k(e, t = 500) {
  const [n, r] = o(e);
  return s(() => {
    const i = setTimeout(() => r(e), t);
    return () => {
      clearTimeout(i);
    };
  }, [e, t]), n;
}
function A() {
  const [e, t] = o({
    width: typeof window > "u" ? void 0 : window.innerWidth,
    height: typeof window > "u" ? void 0 : window.innerHeight
  });
  return s(() => {
    function n() {
      t({
        width: window.innerWidth,
        height: window.innerHeight
      });
    }
    return window.addEventListener("resize", n), n(), () => window.removeEventListener("resize", n);
  }, []), e;
}
const C = typeof window < "u" ? I : s;
function W(e, t) {
  const n = E(e);
  C(() => {
    n.current = e;
  }, [e]), s(() => {
    if (!t && t !== 0)
      return;
    const r = setTimeout(() => {
      n.current();
    }, t);
    return () => {
      clearTimeout(r);
    };
  }, [t]);
}
function V() {
  const { width: e } = A();
  let t = "desktop";
  return e && e <= p.MOBILE ? t = "mobile" : e && e <= p.TABLET && (t = "tablet"), {
    currentWidth: e,
    currentDevice: t,
    isMobile: t === "mobile",
    isTablet: t === "tablet",
    isDesktop: t === "desktop",
    isReady: typeof window < "u"
  };
}
function x(e, t, n) {
  s(() => {
    if (window)
      return window.addEventListener(e, t, n), () => {
        window.removeEventListener(e, t, n);
      };
  }, [e, t, n]);
}
function H() {
  const e = E(!1), t = u(() => e.current, []);
  return s(() => (e.current = !0, () => {
    e.current = !1;
  }), []), t;
}
function M(e) {
  return Array.isArray(e);
}
function _({
  promiseFn: e,
  enabled: t = !0,
  initialData: n
}) {
  const r = E(0), i = H(), [f, w] = o(n ?? void 0), [l, m] = o(t ?? !1), [L, v] = o(void 0), [g, D] = o(t ?? !1), [h, S] = o(!1), [y, R] = o(!1), a = u(
    async (...d) => {
      const T = ++r.current;
      l || m(!0);
      try {
        if (!M(d))
          throw new Error("Invalid arguments provided to the promise function.");
        const c = await e(...d);
        i() && T === r.current && w(c);
      } catch (c) {
        if (i() && T === r.current)
          throw c instanceof Error ? v(c) : v(new Error("An unknown error occurred")), c;
      } finally {
        m(!1), D(!1), S(!1);
      }
    },
    [i, l, e]
  );
  s(() => {
    g && !h && a();
  }, [g, a, h]);
  const b = u(
    async (...d) => {
      S(!0), D(!0), R(!0), await a(...d);
    },
    [a]
  );
  return { data: f, loading: l, error: L, refetching: h, refetch: b, hasRefetch: y };
}
export {
  p as BREAKPOINTS,
  K as EVENTS_HE,
  N as LOCALIZED_DOMAINS,
  U as MODULES_HE,
  Z as addDaysToDate,
  j as calculateDaysDifference,
  q as convertDateToISODateString,
  G as debounce,
  J as dispatchEvent,
  Q as formatDateToLocale,
  X as getHeaders,
  Y as getReverseRanges,
  $ as getServerHeaders,
  ee as isBetween,
  te as isBrowser,
  ne as isSameDay,
  re as parseCookies,
  O as useBoolean,
  k as useDebounce,
  V as useDevice,
  x as useEvent,
  H as useMountedState,
  _ as usePromise,
  W as useTimeout,
  A as useWindowSize
};
